import request from '@/shared/api/request';

export const resendTeamMemberInvite = ({
  uuid,
  email,
}: {
  uuid: string;
  email: string;
}): Promise<{ email: string }> =>
  request({
    url: `/teams/${uuid}/invitations/resend/`,
    method: 'POST',
    data: { email },
  });
